<template>
  <div class="wrapper">
    <div class="title">Соцсети</div>
    <div
      class="socials"
      :class="{
        disabled: preview,
      }"
    >
      <template v-for="social in socials">
        <div
          v-if="!localValue[social.id].link && edited !== social.id"
          :key="social.id"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: social.tooltip,
            placement: 'top',
          }"
          :class="`social social--${social.id}`"
          @click="add(social)"
        >
          <social-icon :social="social.id" />
        </div>
      </template>
    </div>
    <div class="list">
      <template v-for="social in socials">
        <div v-if="edited === social.id" :key="social.id" class="item">
          <div :class="`item-icon item-icon--${social.id}`">
            <social-icon :social="social.id" />
          </div>
          <div class="edit-form">
            <c-input
              v-model="localValue[social.id].tmpLink"
              class="text"
              @enter="change(social)"
              :required="isSubmitted && errorText"
              :required-message="isSubmitted && errorText"
            />
            <div class="actions">
              <c-button
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Отменить',
                  placement: 'top',
                }"
                size="iconic"
                :icon="{ icon: 'close', color: 'secondary' }"
                class="reset"
                @click="reset(social)"
              />
              <c-button
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Применить',
                  placement: 'top',
                }"
                size="iconic"
                :icon="{ icon: 'check', color: 'success' }"
                class="apply"
                @click="change(social)"
              />
            </div>
          </div>
        </div>

        <div v-else-if="localValue[social.id].link" :key="social.id" class="item">
          <div :class="`item-icon item-icon--${social.id}`">
            <social-icon :social="social.id" />
          </div>
          <div class="view">
            <a :href="localValue[social.id].link">{{ localValue[social.id].link }} </a>
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Редактировать',
                placement: 'top',
              }"
              size="iconic"
              :icon="{ icon: 'edit' }"
              class="edit"
              @click="edit(social)"
            />
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                content: 'Удалить',
                placement: 'top',
              }"
              size="iconic"
              :icon="{ icon: 'trash', color: 'secondary' }"
              class="remove"
              @click="remove(social)"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SocialIcon from "@/components/social-icon";
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import { REQUIRED_ERROR, FORMAT_ERROR } from "@/constants/errorFieldValues";

import { isURL } from "@/utils/validate/url";

const socials = [
  {
    id: "fb",
    tooltip: "Facebook",
  },
  {
    id: "vk",
    tooltip: "Vkontakte",
  },
  {
    id: "ok",
    tooltip: "Одноклассники",
  },
  {
    id: "li",
    tooltip: "LinkedIn",
  },
  {
    id: "in",
    tooltip: "Instagram",
  },
  {
    id: "tt",
    tooltip: "TikTok",
  },
  {
    id: "yt",
    tooltip: "YouTube",
  },
];

export default {
  components: { SocialIcon, CInput, CButton },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: {
        fb: {
          link: "",
          tmpLink: "",
        },
        vk: {
          link: "",
          tmpLink: "",
        },
        ok: {
          link: "",
          tmpLink: "",
        },
        li: {
          link: "",
          tmpLink: "",
        },
        in: {
          link: "",
          tmpLink: "",
        },
        tt: {
          link: "",
          tmpLink: "",
        },
        yt: {
          link: "",
          tmpLink: "",
        },
      },
      isSubmitted: false,
      edited: null,
      socials,
    };
  },

  computed: {
    errorText() {
      if (!this.edited) return null;

      const data = this.localValue[this.edited];

      const value = data.tmpLink.trim();

      if (!value) return REQUIRED_ERROR;

      if (!isURL(value)) return FORMAT_ERROR;

      return null;
    },
  },

  watch: {
    localValue: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    value(v) {
      this.setData(v);
    },
    edited(v) {
      this.isSubmitted = false;
      if (!v) {
        return;
      }
      this.$nextTick(() => {
        const form = this.$el.querySelector(".edit-form");
        if (!form) return;
        const input = form.querySelector("input");
        if (input) input.focus();
      });
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const fieldValue = value.value || {};

      Object.keys(this.localValue).forEach((key) => {
        this.localValue[key].link = fieldValue[key] || "";
      });
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      const newValue = {};
      Object.entries(this.localValue).forEach(([key, value]) => {
        newValue[key] = value.link;
      });
      this.$emit("input", { value: newValue });
      if (this.inited) this.$emit("change");
    },
    add(social) {
      this.edited = social.id;
    },
    change(social) {
      const { id } = social;
      const data = this.localValue[id];
      const newLink = data.tmpLink.trim();

      if (!newLink) {
        this.isSubmitted = true;
        return;
      }

      const isValid = isURL(newLink);
      if (!isValid) {
        this.isSubmitted = true;
        return;
      }

      this.isSubmitted = false;
      data.link = newLink;
      this.edited = null;
    },
    reset() {
      this.edited = null;
    },
    edit(social) {
      const { id } = social;
      const data = this.localValue[id];
      data.tmpLink = data.link;
      this.edited = id;
    },
    remove(social) {
      const { id } = social;
      const data = this.localValue[id];
      data.link = "";
      data.tmpLink = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.wrapper {
  margin-top: -18px;
}
.title {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
.socials {
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
}

.social {
  color: $label;
  width: 48px;
  height: 48px;

  margin: 5px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid #d3d8df;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  &--li {
    .icon {
      transform: translateY(-2px);
    }
  }
}
.socials:not(.disabled) {
  .social {
    cursor: pointer;
    &:hover {
      color: $color-primary;
      border-color: $color-dark;
    }
  }
}
.list {
  .item {
    display: flex;
    align-items: center;
    font-size: 15px;

    &:first-child {
      margin-top: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .item-icon {
      margin-right: 15px;
      width: 48px;
      height: 48px;

      color: white;

      flex-shrink: 0;
      border-radius: 50%;

      display: flex;
      justify-content: center;
      align-items: center;

      &--vk {
        background-color: #45668e;
      }

      &--fb {
        background-color: #1877f2;
      }

      &--ok {
        background-color: #ed812b;
      }

      &--li {
        background-color: #0077b5;

        .icon {
          transform: translateY(-2px);
        }
      }

      &--tt {
        background-color: #000;
      }

      &--in {
        background: linear-gradient(
          229.87deg,
          #405de6 14.41%,
          #833ab4 30.97%,
          #e1306c 47.54%,
          #f56040 63.4%,
          #fcaf45 82.08%
        );
      }

      &--yt {
        background-color: #ff0000;
      }
    }

    .edit-form {
      display: flex;
      position: relative;
      flex-grow: 1;

      .text {
        flex-grow: 1;
      }

      .actions {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
      }

      .apply {
        margin-left: 15px;
      }

      /deep/ .c-input-input {
        padding-right: 60px;
      }

      /deep/ {
        .c-input-required {
          position: absolute !important;;
        }
      }
    }

    .view {
      display: flex;
      align-items: center;
      line-height: 1.2;

      a {
        margin-right: 5px;
        word-break: break-all;
        flex-shrink: 1;
      }

      .edit,
      .remove {
        margin-left: 15px;
      }
    }
  }
}
</style>
